/**
 * BelegePage — standalone receipts page: upload a receipt, work through the
 * unassigned queue, and match each one to a transaction. The candidate picker
 * is a single sheet driven by `pickerReceipt`, opened either by the upload
 * card (auto, when the upload returned candidates) or by a queue row's
 * "Zuordnen" button.
 */
import { useState } from 'react';
import { PageHeader } from '../components/layout/PageHeader.tsx';
import { CandidatePicker } from './belege/CandidatePicker.tsx';
import { ReceiptQueue } from './belege/ReceiptQueue.tsx';
import { ReceiptUploadCard } from './belege/ReceiptUploadCard.tsx';
import type { Receipt } from '../lib/types.ts';

export default function BelegePage() {
  const [pickerReceipt, setPickerReceipt] = useState<Receipt | null>(null);

  return (
    <div>
      <PageHeader title="Belege" subtitle="Belege hochladen und Buchungen zuordnen" />

      <div className="w-full space-y-8 px-4 py-6 sm:px-6">
        <ReceiptUploadCard onOpenPicker={setPickerReceipt} />
        <ReceiptQueue onZuordnen={setPickerReceipt} />
      </div>

      <CandidatePicker
        // Keyed on the receipt id so the internal amount filter resets when a
        // different receipt opens, without an effect-driven `setState`.
        key={pickerReceipt?.id ?? 'none'}
        receipt={pickerReceipt}
        onOpenChange={(open) => {
          if (!open) setPickerReceipt(null);
        }}
      />
    </div>
  );
}
